/**
 * Evidence-reference mark (Document World). Tags a literal `[E7]`-shaped span in text with the
 * evidence id it points at, so a host (the 3D dock) can resolve the span to a world node without
 * re-parsing document text. A mark, not a node — it rides on existing text and survives edits like
 * `commitment`/`attribution`. INTERNAL PM file; never re-exported from `index.ts`.
 */

import type { MarkSpec } from 'prosemirror-model';

export const EVIDENCE_REF_MARK = 'evidence_ref';

export const evidenceRefMark: MarkSpec = {
  attrs: {
    eid: { default: '' },
  },
  // Non-inclusive: typing right after a `[E7]` span should not silently extend the reference.
  inclusive: false,
  parseDOM: [
    {
      tag: 'span[data-evidence-ref]',
      getAttrs: (dom) => {
        const el = dom as HTMLElement;
        return {
          eid: el.getAttribute('data-evidence-ref') ?? '',
        };
      },
    },
  ],
  toDOM: (mark) => [
    'span',
    {
      'data-evidence-ref': mark.attrs.eid,
      class: 'docit-evidence-ref',
    },
    0,
  ],
};
